import { Component } from "react"
import PropTypes from "prop-types"
import takeRight from "lodash/takeRight"
import _map from "lodash/map"
import moment from "moment"

export default class DailyCallToActionClicksChart extends Component {
  constructor(props) {
    super(props)
  }

  async componentDidMount() {
    const Highcharts = await import("highcharts")
    Highcharts.setOptions(window.globalHighchartsOptions)

    const settings = {
      chart: {
        animation: false,
        renderTo: this.chartContainer,
        height: 250,
        spacing: [10, 0, 10, 0],
      },
      credits: { enabled: false },
      title: {
        text: "",
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        series: {
          animation: false,
        },
      },
      xAxis: {
        type: "datetime",
        tickmarkPlacement: "on",
        labels: {
          step: 4,
          style: {
            color: "#999",
            fontSize: "14",
            fontWeight: "700",
          },
        },
        offset: 10,
        gridLineWidth: 4,
        gridLineColor: "#f5f5f5",
        lineWidth: 0,
        tickWidth: 0,
      },
      yAxis: [
        {
          opposite: true,
          title: {
            enabled: false,
          },
        },
        {
          title: {
            enabled: false,
          },
          labels: {
            style: {
              color: "#999",
              fontSize: "14",
              fontWeight: "700",
            },
            formatter: data => {
              return Highcharts.numberFormat(data.value, 0)
            },
          },
          gridLineWidth: 0,
        },
      ],
      series: [
        {
          name: "Daily",
          yAxis: 1,
          color: "#333",
          lineWidth: 3,
          marker: {
            enabled: true,
            radius: 6,
          },
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      ],
      tooltip: {
        animation: false,
        backgroundColor: "#333",
        borderWidth: 0,
        borderRadius: 10,
        headerFormat: '<span style="color: #999">{point.key}</span>',
        padding: 8,
        pointFormat: "<br><b>{point.y} clicks</b>",
        shadow: false,
        style: {
          color: "#fff",
          fontSize: 14,
        },
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 483,
            },
            chartOptions: {
              series: {
                data: takeRight(this.extractDataForTotalClicksLayer(), 15),
              },
              xAxis: {
                categories: takeRight(this.xAxisCategories(), 15),
              },
            },
          },
          {
            condition: {
              minWidth: 484,
            },
            chartOptions: {
              series: {
                data: this.extractDataForTotalClicksLayer(),
              },
              xAxis: {
                categories: this.xAxisCategories(),
              },
            },
          },
        ],
      },
    }

    this.chart = new Highcharts.Chart(settings)
  }

  componentWillUnmount() {
    this.chart.destroy()
  }

  xAxisCategories() {
    return _map(this.props.data, row => {
      return moment(row.date).format("MMM D")
    })
  }

  extractDataForTotalClicksLayer() {
    return _map(this.props.data, d => {
      return parseInt(d.daily_cta_clicks)
    })
  }

  render() {
    return (
      <div
        className="chart-container round-grid-chart"
        ref={c => (this.chartContainer = c)}
      />
    )
  }
}

DailyCallToActionClicksChart.propTypes = {
  data: PropTypes.array,
}
